<template>
  <v-container>
    <!-- {{bookInfo}} -->
    <v-card class="mt-6">
      <v-card-text>
        <v-form ref="form">
          <v-row>
            <v-col cols="12" md="6" class="pb-0">
              <v-text-field
                :rules="[rules.required]"
                v-model="bookInfo.bookname"
                label="Book Name"
                outlined
                dense
                required
                class="pb-0"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" class="pb-0">
              <v-text-field
                :rules="[rules]"
                v-model="bookInfo.bookdsecription"
                class="pb-0"
                label="Book Dsecription"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col class="pb-0" cols="12" lg="6">
              <v-autocomplete
                :rules="[rules.required]"
                v-model="bookInfo.lang.langid"
                :items="listLang"
                dense
                label="Lang"
                outlined
                item-text="langname"
                item-value="langid"
              ></v-autocomplete>
            </v-col>
            <v-col class="pb-0" cols="12" lg="6">
              <v-autocomplete
                :rules="[rules.requiredArray]"
                v-model="categoriesObject"
                :items="categoriesObject"
                outlined
                dense
                :readonly="true"
                chips
                small-chips
                :label="$t('bookUpload.categories')"
                multiple
                item-text="categoryname"
                item-value="categoryid"
                @focus="dialogCategoryTree = true"
              ></v-autocomplete>
            </v-col>
            <v-col class="pb-0" cols="12" lg="6">
              <v-autocomplete
                clearable
                :rules="[rules.required]"
                :search-input.sync="authorNameSearch"
                v-model="bookInfo['author'][0]"
                :items="listAuthors"
                dense
                :label="$t('bookUpload.authorName')"
                outlined
                item-text="authorname"
                return-object
                item-value="authorid"
                @keyup="searchAuthor()"
              ></v-autocomplete>
            </v-col>
            <v-col class="pb-0" cols="12" lg="6">
              <v-text-field
                clearable
                v-model="bookInfo['booklink']"
                dense
                :label="$t('bookUpload.bookDriveLink')"
                outlined
              ></v-text-field>
            </v-col>
            <v-col class="pb-0" cols="12" lg="6">
              <v-autocomplete
                clearable
                :rules="[rules.requiredArray]"
                v-if="bookInfo.version.length != 0"
                :search-input.sync="publisherNameSearch"
                v-model="bookInfo.version[0]['publisher'][0]"
                :items="listPublishers"
                dense
                :label="$t('bookUpload.publisher')"
                outlined
                item-text="publishername"
                return-object
                item-value="publisherid"
                @keyup="searchPublishers()"
              ></v-autocomplete>
            </v-col>
            <v-col class="pb-0" cols="12" lg="6">
              <v-text-field
                clearable
                v-if="bookInfo.version.length != 0"
                v-model="publisheryear"
                dense
                :label="$t('bookUpload.publisherYear')"
                outlined
              ></v-text-field>
            </v-col>

            <v-col class="pb-0" cols="6" lg="3">
              <v-switch
                class="mx-3"
                v-model="bookInfo.ispublish"
                flat
                :label="$t('bookUpload.IsPublish')"
              ></v-switch>
            </v-col>
            <v-col class="pb-0" cols="6" lg="3">
              <v-switch
                class="mx-3"
                v-model="bookInfo.isdownloadable"
                flat
                :label="$t('bookUpload.IsDownloadable')"
              ></v-switch>
            </v-col>
          </v-row>
          <!-- ------------------------------ -->
          <!-- وقت عم احفظ كتاب ماعم تنحفظ معه معلومات الكتاب -->
              <v-row
                no-gutters
                v-for="(item, index) in bookInfo.version[0].metainfo"
                :key="index"
              >
                <v-col md="6" cols="5" class="px-2">
                  <v-text-field
                    class="mt-6"
                    :label="$t('bookUpload.metaName')"
                    :rules="[rules.required]"
                    v-model="item.meta_name"
                    outlined
                    dense
                  >
                  </v-text-field>
                </v-col>
                <v-col md="5" cols="5" class="px-1">
                  <v-text-field
                    class="mt-6"
                    :label="$t('bookUpload.metaValue')"
                    :rules="[rules.required]"
                    v-model="item.meta_value"
                    outlined
                    dense
                  >
                  </v-text-field
                ></v-col>
                <v-col md="1" cols="2" class="px-1 text-center"
                  ><span
                    style="cursor: pointer"
                    class=""
                    @click="removerMeta(index)"
                    ><i class="pt-6 status fa fa-times-circle red--text"></i></span
                ></v-col>
              </v-row>
              <!-- ------------------------------ -->
        </v-form>
        <v-card-actions class="pa-0">
          <v-btn
            class="mr-3"
            color="success"
            @click="bookInfo.version[0].metainfo.push({'meta_name' : '' , metaValue : '' })"
            :loading="loadingAdd"
          >
            {{ $t("bookUpload.addMeta") }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            class="mr-3"
            color="primary"
            @click="submit()"
            :loading="loadingAdd"
          >
            {{ $t("public.save") }}
          </v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>
    <SelectTreeCategory
      :dialogCategoryTree="dialogCategoryTree"
      v-on:closeCatDialog="closeCategory($event)"
      v-on:closeCatDialogWithCategories="
        closeCatDialogWithCategoriesMethod($event)
      "
    />
  </v-container>
</template>
<script>
import SelectTreeCategory from "@/components/Category/SelectTreeCategory";
export default {
  data() {
    return {
      bookInfo: {
        lang: {},
        author: {},
        version: [{metainfo : []}],
      },
      publisheryear : null ,
      loadingAdd: false,
      listPublishers: [],
      listLang: [],
      listAuthors: [],
      categoriesObject: [],
      dialogCategoryTree: false,
      authorNameSearch: "",
      publisherNameSearch: "",

      rules: {
        required: (value) => !!value || this.$t("valid.required"),
        requiredArray: (value) => value != "" || this.$t("valid.required"),
      },
    };
  },
  created() {
    this.getBookInfo();
    this.getAllLang();
    this.getAllAuthors();
    this.getAllPublishers();
  },
  components: {
    SelectTreeCategory,
  },
  methods: {
    getBookInfo() {
      this.$store
        .dispatch("GetFromAPI", `/mybook/${this.$route.params.bookID}`)
        .then((response) => {
          this.bookInfo = response.data.data;
          this.publisheryear = this.bookInfo.version[0]['publisher'][0]['publisheryear'] 
          let categories = [];
          for (
            let index = 0;
            index < this.bookInfo.categories.length;
            index++
          ) {
            categories.push(this.bookInfo.categories[index]);
          }
          this.categoriesObject = categories;
        });
    },
    getAllLang() {
      this.$store.dispatch("GetFromAPI", "/lang").then((response) => {
        this.listLang = response["data"]["data"];
      });
    },
    getAllAuthors() {
      this.$store
        .dispatch(
          "GetFromAPI",
          "/author?per_page=20&filter[authorname]=" + this.authorNameSearch
        )
        .then((response) => {
          this.listAuthors = response["data"]["data"];
          this.listAuthors.push({
            authorid: this.bookInfo.author[0].authorid,
            authorname: this.bookInfo.author[0].authorname,
          });
        });
    },
    closeCategory() {
      this.dialogCategoryTree = false;
    },
    closeCatDialogWithCategoriesMethod(vals) {
      this.categoriesObject = vals;
      let categoryID = [];
      for (let index = 0; index < vals.length; index++) {
        categoryID.push(vals[index]["categoryid"]);
      }
      this.dialogCategoryTree = false;
      this.bookInfo.category = categoryID;
    },
    searchAuthor() {
      if (event.keyCode != 40 && event.keyCode != 38 && event.keyCode != 13) {
        this.getAllAuthors();
      }
    },
    getAllPublishers() {
      this.$store
        .dispatch(
          "GetFromAPI",
          "/admin/publisher?per_page=20&filter[publishername]=" +
            this.publisherNameSearch
        )
        .then((response) => {
          this.listPublishers = response["data"]["data"];
          this.listPublishers.push({
            publisherid: this.bookInformation.publisher.publisherid,
            publishername: this.bookInformation.publisher.publishername,
            year: this.bookInformation.publisher.year,
          });
        });
    },
    searchPublishers() {
      if (event.keyCode != 40 && event.keyCode != 38 && event.keyCode != 13) {
        this.getAllPublishers();
      }
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.loadingAdd = true;

        let DataForm = {
          Param: {
            bookname: this.bookInfo.bookname,
            ispublish: this.bookInfo.ispublish,
            langid: this.bookInfo.lang.langid,
            bookdsecription: this.bookInfo.bookdsecription,
            booklink: this.bookInfo.booklink,
            category: this.categoriesObject.map((a) => a.categoryid),
            author: {
              authorid: this.bookInfo["author"][0]["authorid"],
            },
            metainfo: this.bookInfo.version[0]['metainfo'],
            publisher: {
              year: this.publisheryear,
              publisherid:
                this.bookInfo.version[0]["publisher"][0]["publisherid"],
            },
            isdownloadable : this.bookInfo.isdownloadable
          },
          API: `/mybook/${this.$route.params.bookID}`,
        };

        this.$store
          .dispatch("PutToAPI", DataForm)
          .then(() => {
            this.$store.dispatch("PushSuccessMsg", this.$t('public.successSeved'));
            // this.getBookInfo()
            this.$router.push({ name: 'MyBooks'})
          })
          .catch((err) => {
            this.$store.dispatch(
              "PushErrorMsg",
              err.data.data[Object.keys(err.data.data)[0]]
            );
          })
          .finally(() => {
            this.loadingAdd = false;
          });
      }else {
        this.$store.dispatch("PushErrorMsg", this.$t("public.DataNotValid"));
      }
    },
  },
};
</script>